module.exports = __webpack_public_path__ + "img/typing-race-logo.c6f5f05d.png";